<div class="modal-header card-header cabecera">
    <span class="text-blue text-125">Recorrido · {{ asesor.nombre }}</span>
    <span class="text-muted">{{ fecha() }}</span>
    <button type="button" class="btn btn-light btn-sm ml-auto" (click)="activeModal.close()" title="Cerrar">
        <i class="fa fa-times"></i>
    </button>
</div>

<div class="modal-body p-0 cuerpo">
    <div #contenedorMapa class="mapa"></div>
    <div class="lista">
        <div class="leyenda">
            <div><span class="muestra" style="background:#1f6fd1"></span> {{ dia.turnos[0]?.nombre || 'Turno 1' }}</div>
            <div *ngIf="dia.turnos.length > 1"><span class="muestra" style="background:#e8730c"></span> {{ dia.turnos[1].nombre }}</div>
            <div><span class="muestra colegio"></span> Punto oficial del colegio</div>
            <div><span class="muestra gps"></span> GPS automático
                <small class="text-muted">
                    <ng-container *ngIf="cargandoGps">(cargando…)</ng-container>
                    <ng-container *ngIf="!cargandoGps">({{ posicionesGps }} puntos)</ng-container>
                </small>
            </div>
            <div><span class="muestra alerta"></span> Lejos del colegio o con error</div>
        </div>

        <div *ngIf="!visitas.length" class="text-muted p-2">No marcó lugares este día.</div>
        <div *ngIf="sinUbicacion" class="text-muted p-2">{{ sinUbicacion }} marca(s) sin ubicación del teléfono: no se dibujan.</div>

        <button type="button" *ngFor="let v of visitas" class="visita" [class.con-alerta]="v.lejos || v.error" (click)="irA(v)">
            <span class="numero" [style.background]="v.color">{{ v.numero }}</span>
            <span class="texto">
                <b>{{ v.lugar }}</b>
                <small class="d-block">{{ hora(v.llegada) }} – {{ hora(v.salida) || 'sin "Salí"' }}
                    <ng-container *ngIf="v.distancia !== null"> · {{ v.distancia }} m</ng-container>
                </small>
                <small *ngIf="v.error" class="d-block text-danger">{{ v.error }}</small>
            </span>
        </button>
    </div>
</div>
